module.exports = __webpack_public_path__ + "static/img/2367_phase_function_Paper_PointsHejduk_Prediction.87f4c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2367_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 31Uh
// module chunks = 0